/**
 * Demo Course Loader (Stage 10 — Demo Datasets).
 *
 * One-click entry point to the dataset picker. Rendered in the dashboard.
 * Opens the shared `LoadDemoModal` which lists every available demo dataset.
 */

import React, { useState } from 'react';
import { Button } from '../shared';
import { LoadDemoModal } from './LoadDemoModal';

export interface DemoCourseLoaderProps {
  /** Optional external opener. When provided, the button delegates to it
   *  (e.g. the app-level modal). Otherwise this component manages its own modal. */
  onOpenLoadDemo?: () => void;
}

export function DemoCourseLoader({ onOpenLoadDemo }: DemoCourseLoaderProps): React.ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    if (onOpenLoadDemo) {
      onOpenLoadDemo();
    } else {
      setIsOpen(true);
    }
  };

  return (
    <div className="demo-course-loader">
      <p>Load a pre-configured demo dataset with realistic attendance data to explore all features.</p>
      <Button variant="secondary" onClick={handleClick}>
        Load Demo Course
      </Button>
      {!onOpenLoadDemo && (
        <LoadDemoModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </div>
  );
}
